// extracted by mini-css-extract-plugin
export default {"overlay":"lz-z","bodyOpen":"mz-z","content":"nz-z","header":"oz-z","close":"pz-z","closeNoHeading":"qz-z"};